import { Injectable, OnDestroy, inject } from '@angular/core';
import { NotificationStore } from '../notifications/services/notification.store';

@Injectable({
  providedIn: 'root'
})
export class VisibilidadeService implements OnDestroy {
  private readonly notificationStore = inject(NotificationStore);

  iniciar(): void {
    this.setupVisibilityListener();
  }

  ngOnDestroy(): void {
    this.removeVisibilityListener();
  }

  private setupVisibilityListener(): void {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  private removeVisibilityListener(): void {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  private readonly handleVisibilityChange = (): void => {
    if (document.visibilityState === 'visible') {
      this.notificationStore.purgeExpired();
    }
  };
}